// Face.jsx
import React from "react";

const Face = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="text-9xl">
        <img src="/assets/smile.gif" alt="Smiling face" />
      </div>
    </div>
  );
};

export default Face;
